import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { IVendorItemComment } from '../../interface/IVendorItemComment';
import * as _ from 'lodash';
import { VendorService } from '../../vendor.service';
import { filter } from 'rxjs-compat/operator/filter';
import { FormGroup, FormBuilder, FormArray, AbstractControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ItemDetailedComponent } from '../item-detailed/item-detailed.component';
import { ItemService } from '../item.service';
import { NgFor, NgIf, NgStyle } from '@angular/common';
import { NgClickOutsideDirective, NgClickOutsideExcludeDirective } from 'ng-click-outside2';

@Component({
    selector: 'app-item-comment',
    templateUrl: './item-comment.component.html',
    styleUrls: ['./item-comment.component.scss'],
    standalone: true,
    imports: [NgClickOutsideDirective, NgClickOutsideExcludeDirective, FormsModule, ReactiveFormsModule, NgFor, NgStyle, NgIf]
})
export class ItemCommentComponent implements OnInit {
  @Input() fg: FormGroup;
  @Output() closeModal = new EventEmitter();
  showInfoModal = false;
  comments: IVendorItemComment[];
  newCommentsFG: FormGroup;
  adminOrVendorManger = false;

  constructor(private fb: FormBuilder,
    private itemService: ItemService) {}

  ngOnInit() {
    this.adminOrVendorManger = ['ADMIN', 'VENDORMGR'].includes(sessionStorage.getItem('user_role'));
    this.comments = this.fg.getRawValue().comments;
    this.newCommentsFG = this.fb.group({commentsArray:
      this.itemService.getCommentsArrayControls(this.comments)
    });
  }

  patchComment() {
    if (!this.adminOrVendorManger) {
      return;
    }
    const newValues = this.newCommentsFG.getRawValue().commentsArray;
    this.fg.controls.comments.patchValue(newValues);
    this.closeCommentModal();
  }

  closeCommentModal(): void {
    this.closeModal.emit();
  }
}
